import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Event as RouterEvent, NavigationCancel, NavigationError, NavigationExtras, NavigationStart, PRIMARY_OUTLET, Router } from '@angular/router';
import { RoutingConfig } from 'routing.config';
import { GlobalActions } from './global.actions';

@Injectable()
export class RouteActions {
    constructor(private router: Router, private location: Location) {}

    public init(): void {
        this.router.events.subscribe((event: RouterEvent) => {
            this.navigationInterceptor(event);
        });
        this.router.routeReuseStrategy.shouldReuseRoute = function(): boolean {
            return false;
        };
    }
    public navigate(commands: any[], extras?: NavigationExtras, forceReload?: boolean): Promise<boolean> {
        if (!!forceReload) {
            this.router.navigated = false;
        }
        return this.router.navigate(commands, extras);
    }

    public goToRoot(): Promise<boolean> {
        return this.navigate(['']);
    }

    public goToAccessDenied(state?: { [k: string]: any }): Promise<boolean> {
        const navigationExtras = { queryParamsHandling: 'preserve', state } as NavigationExtras;
        return this.navigate(['access-denied'], navigationExtras);
    }

    public goToNotFound(): Promise<boolean> {
        return this.navigate(['not-found'], { replaceUrl: true });
    }
    public back(): void {
        this.location.back();
    }

    public goToReturnUrl(url: string): void {
        if (RouteActions.isExternalUrl(url)) {
            this.goToExternalUrl(url);
        }
        if (url.indexOf(RoutingConfig.DepartmentTaskList.Base) === 0 && !ETR.currentUserTraits.canSeeDepartmentTaskList) {
            this.goToRoot();
        } else {
            const urlTree = this.router.parseUrl(url);
            const urlWithoutParams = urlTree.root.children[PRIMARY_OUTLET].segments.join('/');
            this.navigate([urlWithoutParams], { queryParams: urlTree.queryParams });
        }
    }

    public goToExternalUrl(url: string): void {
        // используем нативный подход, т.к. редирект на абсолютный адрес через Location не работает: https://github.com/angular/angular/issues/20167
        // this.location.go(url);
        window.location.href = url;
    }

    public static isExternalUrl(url: string): boolean {
        return url && (url.indexOf('http://') === 0 || url.indexOf('https://') === 0);
    }

    private navigationInterceptor(event: RouterEvent): void {
        if (event instanceof NavigationStart) {
            if (ETR.isProduction && !ETR.currentUserTraits.isSuperUser) {
                const isRouteToDisabledRequest = ETR.currentUserTraits.disabledRequests.some(
                    disabledBpCode => event.url.toLowerCase().indexOf(`/${disabledBpCode.toLowerCase()}/`) > -1
                );
                if (isRouteToDisabledRequest) {
                    this.goToNotFound();
                    return;
                }
            }
            // Здесь спиннер включаем. Загрузившийся компонент сам выключит, когда ему надо
            GlobalActions.showSpinner();
        }
        // TODO: REMOVE hideSpinner in component, when all resource loaded
        if (event instanceof NavigationCancel || event instanceof NavigationError) {
            GlobalActions.hideSpinner();
        }
    }
}
